import { CommonModule, DecimalPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { TimeDiffPipe } from './pipes/time-diff.pipe';
import { PdatePipe } from "./pipes/pdate.pipe";
import { TomanPipe } from "./pipes/toman.pipe";

const shared = [
  TimeDiffPipe,
  PdatePipe,
  TomanPipe
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [shared],
  exports: [shared],
  providers: [DecimalPipe],
})
export class CoreModule { }

export * from './pipes/time-diff.pipe';
export * from './pipes/pdate.pipe';
export * from './pipes/toman.pipe';